/**
 * 数值条件格式稳定常量。
 *
 * @see types.ts · utils/numericalConditionalFormat.ts
 */

import type { INumericalIconGroup } from './types';

/**
 * 条件格式面板：表示「不展示图标」的特殊值（与具体 icon id 区分）。
 *
 * @core 面板 Radio 与 normalizeNumericalIconValue 共用 sentinel。
 */
export const NUMERICAL_ICON_NONE = 'none';

/**
 * 条件格式图标选择器：三分组配置。
 * 同时决定面板 Tab 分类与 splitNumericalIconByPlacement 的左右侧放置规则。
 *
 * @core ChartSettingsV2 图标选择与 AliTableAnalytics 左右位渲染共用。
 */
export const NUMERICAL_ICON_GROUPS = [
  {
    key: 'change',
    labelKey: 'dbl_chart_condition_icon_change',
    icons: ['rising-arrow-icon', 'down-arrow-icon', 'jian'],
  },
  {
    key: 'sentiment',
    labelKey: 'dbl_chart_condition_icon_sentiment',
    icons: ['happy-icon', 'unhappy-icon', 'expressionless-icon'],
  },
  {
    key: 'others',
    labelKey: 'dbl_chart_condition_icon_others',
    icons: ['like', 'dislike'],
  },
] as const satisfies readonly INumericalIconGroup[];

/**
 * 条件格式规则未指定 icon 时的默认图标 id。
 *
 * @core 面板新建规则默认值与单元格渲染 fallback 共用。
 */
export const DEFAULT_NUMERICAL_ICON = 'arrow-other-down';
